<template>
  <div class="Questioninfo">
    <div class="title" :class="operation=='Detail'?'form_Readonly':''">
      <span
        style="color:red"
        v-if="item.isMust"
      >*</span>
      <span>{{item.number}}、</span>
      <el-input
        v-model="item.title"
        placeholder="请简单以下题目"
      />
      <div class="Questioninfo_Copy">
        <a
          href="javascript:void(0);"
          @click="DocumentCopy"
          style="color: #707070;"
        >
          <el-icon>
            <document-copy />
          </el-icon>
        </a>
        <a
          href="javascript:void(0);"
          @click="DeleteFilled"
          style="color: #707070;"
        >
          <el-icon>
            <delete-filled />
          </el-icon>
        </a>
      </div>
    </div>
    <div class="cotent" :class="operation=='Detail'?'form_Readonly':''">
      <div>
        <el-input
          v-model="item.hint"
          placeholder="请输入提示内容"
        />
      </div>
    </div>
  </div>
</template>

<script >
export default {
  name: "QuestionnaireSimple",
  props: {
    item: {
      type: Object,
      default: {
        title: "请简答以下题目",
        type: 2,
        number: 1,
        hint: "", //填写提示
        isRandom: false,
        isMust: true,
        minLength: 0, //最少填写多少字
        maxLength: 0, //最多填写多少字
      },
    },
    dataindex: {
      type: Number,
      default: 0,
    },
    operation: {
      type: String,
      default: ""
    }
  },
  setup(props, context) {
    //复制
    const DocumentCopy = () => {
      context.emit("DocumentCopy", props.item);
    };

    //删除
    const DeleteFilled = () => {
      context.emit("DeleteFilled", props.dataindex);
    };
    return {
      DocumentCopy,
      DeleteFilled,
    };
  },
};
</script>

<style lang="scss" scoped>
.form_Readonly {
  pointer-events: none;
}
.Questioninfo {
  background-color: #ffffff;
  padding: 10px 10px;
  margin-bottom: 10px;

  .title {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .Questioninfo_Copy {
      width: 10%;
      // background-color: yellow;
      height: 40px;
      line-height: 40px;
      align-self: center;
      font-size: 26px;
      display: flex;
      justify-content: flex-start;
    }

    .Questioninfo_Copy a:nth-child(1) {
      margin-right: 5px;
    }
  }

  .cotent {
    padding-left: 20px;
  }
}

.Questioninfo:hover {
  border: solid 1px blue;
}
</style><style scoped>
.title /deep/ .el-input__inner {
  font-size: 16px;
  line-height: 50px;
  /* color: #0747a6; */
  background-color: #ffffff;
  border: 0;
}
</style>
